import React, { useEffect, useContext } from "react";

import {
  Grid,
  Card,
  FormControl,
  InputLabel,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Button,
  OutlinedInput,
  FormHelperText,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import feedbackContext from "contexts/feedbackContext";
import { notify, closeSnack, formatError } from "utils/MyFunctions";
import axios from "axios";
import userContext from "contexts/userContext";
import { useIntl, FormattedMessage } from "react-intl";
import { formatMessage } from "utils/MyFunctions";
export default function LivePreviewExample(props) {
  const intl = useIntl();
  //formatMessage(intl, "create_besc_mar");
  const [valid, setValid] = React.useState(false);
  const [transactions, setTransactions] = React.useState([]);
  const [partnersData, setPartnersData] = React.useState([]);
  const PARTENAIRES_API_URL = process.env.REACT_APP_PARTENAIRES_API_URL;

  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext,
  );
  const { role, setRole, locale } = useContext(userContext);

  const [open, setOpen] = React.useState(false);
  const [type, setType] = React.useState("PR");
  const [added, setAdded] = React.useState({
    ep: false,
    rd: false,
  });

  const [errors, setErrors] = React.useState({
    transaction: false,
    contribuable: false,
  });
  const [helpers, setHelpers] = React.useState({
    transaction: "",
    contribuable: "",
  });
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (props.sens.toLowerCase() === "export") {
      setAnchorEl(event.currentTarget);
    } else {
      setType("PR");
      setAnchorEl(null);
      addTransaction();
    }
  };

  const handleCloseM = (type) => {
    setType(type);
    setAnchorEl(null);
    addTransaction();
  };
  const handleClose = () => {
    console.log("CLOSING");
    if (transactions.length == 0 || props.sens.toLowerCase() === "export") {
      console.log("IF NO TRANSACTION");
      setDialogValue({
        ...dialogValue,
        ["transaction"]: "",
        ["contribuable"]:
          role &&
          role.user &&
          role.user.company &&
          role.user.company.account_local === "0" &&
          !role.user.company.special_authorization &&
          !role.user.company.consignataire &&
          !role.user.company.forwarding_agent &&
          ["Chargeur Principal", "Sous Compte Chargeur"].includes(
            role.user.roles[0].name,
          )
            ? role.user.company.taxpayer_id
            : "",
      });
    } else {
      console.log("ELSE ONE OR MORE TRANSACTIONS");
      setDialogValue({
        ...dialogValue,
        ["transaction"]: "",
        ["contribuable"]:
          role &&
          role.user &&
          role.user.company &&
          role.user.company.account_local === "0" &&
          !role.user.company.special_authorization &&
          !role.user.company.consignataire &&
          !role.user.company.forwarding_agent &&
          ["Chargeur Principal", "Sous Compte Chargeur"].includes(
            role.user.roles[0].name,
          )
            ? role.user.company.taxpayer_id
            : transactions[0].contribuable,
      });
    }

    setOpen(false);
  };

  const [dialogValue, setDialogValue] = React.useState({
    transaction: "",
    contribuable: "",
    demande: "",
    circuit: "",
    dossier: "",
  });

  const validateValues = () => {
    let _errors = {
      transaction: false,
      contribuable: false,
    };
    let _helpers = {
      transaction: "",
      contribuable: "",
    };

    if (
      transactions.find((t) => t.transaction === dialogValue.transaction.trim())
    ) {
      _errors["transaction"] = true;
      _helpers["transaction"] = formatMessage(
        intl,
        "create_besc_maritime_import_accordion_transaction_dialog_helper_transaction",
      );
    }

    setErrors(_errors);
    setHelpers(_helpers);
  };

  useEffect(() => {
    console.log("role changed(TRANSACTIONS), role : ", role);
    if (
      props.sens.toLowerCase() !== "export" &&
      role &&
      role.user &&
      role.user.company &&
      role.user.company.account_local === "0" &&
      !role.user.company.special_authorization &&
      !role.user.company.consignataire &&
      !role.user.company.forwarding_agent &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name,
      )
    ) {
      setDialogValue({
        ...dialogValue,
        ["contribuable"]: role.user.company.taxpayer_id,
      });
    }
  }, [role]);

  useEffect(() => {
    console.log(
      "dialogValue changed(TRANSACTIONS), dialogValue : ",
      dialogValue,
    );
  }, [dialogValue]);

  const handleSubmit = async (event) => {
    let _suffix =
      props.sens.toLowerCase() === "export"
        ? type === "EP"
          ? "/api/check-ep-guce"
          : "/api/check-reference-douane"
        : "/api/check-pr-guce";
    let _transactions = [...transactions];
    event.preventDefault();
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: PARTENAIRES_API_URL + _suffix,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      },
      data:
        type === "Référence Douane"
          ? {
              referenceDouane: dialogValue.transaction.trim(),
              numeroContribuable: dialogValue.contribuable.trim(),
            }
          : {
              numeroTransaction: dialogValue.transaction.trim(),
              numeroContribuable: dialogValue.contribuable.trim(),
            },
    };

    setFeedback({ ...feedback, ["bdOpen"]: true });
    let sb = notify(
      formatMessage(
        intl,
        "create_besc_maritime_import_accordion_transaction_dialog_notify_searching",
      ),
      "info",
      "center",
      "bottom",
      false,
      enqueueSnackbar,
    );
    axios
      .request(config)
      .then(async (response) => {
        // response.data = JSON.parse(
        //   '{\r\n    "status": "ok",\r\n    "message": "ok",\r\n    "chargeur": {\r\n        "name": "GROUP SHIYNTUM SARL",\r\n        "niu": "M071913915299W",\r\n        "email": "803201431@qq.com",\r\n        "phone": "677885588",\r\n        "address": "2"\r\n    },\r\n    "ep": {\r\n        "numero_dossier": "BEX095198",\r\n        "numero_circuit": "EP221348EX01C",\r\n        "numero_demande": "EP221348EX01D"\r\n    },\r\n    "portOfLoading": null,\r\n    "countryOfLoading": "CM",\r\n    "portOfDischarge": "BHB",\r\n    "countryOfDischarge": "CN",\r\n    "incoterm": "FOB",\r\n    "assurance": "0.00",\r\n    "poids": "256.38",\r\n    "volume": "332.33",\r\n    "valeur_fob": "30455180.00",\r\n    "valeur_facture": "30455180.00",\r\n    "devise_fob": "CFA",\r\n    "devise_facture": "CFA",\r\n    "nbre_colis": 0,\r\n    "conteneur_20": 0,\r\n    "conteneur_40": 10,\r\n    "vehicles": 0,\r\n    "codesh": "44072902000"\r\n}',
        // );
        console.log("sucess!! response below :");
        console.log(JSON.stringify(response.data));
        console.log("props chargeurs 0 niu : ", props.chargeurs[0].niu);
        if (response.data.status) {
          if (
            response.data.status === "ok" &&
            (props.chargeurs[0].niu === "" ||
              dialogValue.contribuable === props.chargeurs[0].niu ||
              type === "Référence Douane")
          ) {
            _transactions.push(dialogValue);

            setFeedback({ ...feedback, ["bdOpen"]: false });
            closeSnack(sb, closeSnackbar);
            handleClose();
            notify(
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_transaction_dialog_notify_added",
              ),
              "success",
              "center",
              "top",
              true,
              enqueueSnackbar,
            );
            if (type !== "Référence Douane") {
              setAdded({ ...added, ["ep"]: true });
              let _pd = [...partnersData];
              _pd.push({
                transaction: dialogValue.transaction,
                contribuable: dialogValue.contribuable,
                chargeur: response.data.chargeur,
                portOfLoading: response.data.portOfLoading,
                countryOfLoading: response.data.countryOfLoading,
                portOfDischarge: response.data.portOfDischarge,
                countryOfDischarge: response.data.countryOfDischarge,
                incoterm: response.data.incoterm,
                assurance: response.data.assurance,
                poids: response.data.poids,
                volume: response.data.volume,
                valeur_fob: response.data.valeur_fob,
                valeur_facture: response.data.valeur_facture,
                devise_fob: response.data.devise_fob,
                devise_facture: response.data.devise_facture,
                nbre_colis: response.data.nbre_colis,
                conteneur_20: response.data.conteneur_20,
                conteneur_40: response.data.conteneur_40,
                vehicles: response.data.vehicles,
                codesh: response.data.codesh,
                ep: response.data.ep,
              });
              setPartnersData(_pd);
            } else {
              setAdded({ ...added, ["rd"]: true });
            }
          } else if (response.data.status === "ko") {
            setFeedback({ ...feedback, ["bdOpen"]: false });
            closeSnack(sb, closeSnackbar);
            handleClose();
            notify(
              response.data.message,
              "error",
              "center",
              "top",
              true,
              enqueueSnackbar,
            );
          } else {
            setFeedback({ ...feedback, ["bdOpen"]: false });
            closeSnack(sb, closeSnackbar);
            handleClose();
            notify(
              props.chargeurs[0].niu !== "" &&
                dialogValue.contribuable !== props.chargeurs[0].niu
                ? formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_transaction_dialog_notify_different_shipper",
                  )
                : response.data.message,
              "error",
              "center",
              "top",
              true,
              enqueueSnackbar,
            );

            /* */
          }
        } else {
          setFeedback({ ...feedback, ["bdOpen"]: false });
          closeSnack(sb, closeSnackbar);
          handleClose();
          notify(
            formatMessage(
              intl,
              "create_besc_maritime_import_accordion_transaction_dialog_notify_not_found",
            ),
            "info",
            "center",
            "top",
            true,
            enqueueSnackbar,
          );
        }

        setTransactions(_transactions);
      })
      .catch((error) => {
        console.log("error!! error below :");
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnack(sb, closeSnackbar);
        handleClose();
        notify(
          formatError(error),
          "error",
          "center",
          "top",
          true,
          enqueueSnackbar,
        );
        // setLoading(false);
        // setOpen(false);
        document.body.style.opacity = 1;
      });
    let success = true;
    if (success) {
    }
    //TODO -- set all props to main json and update them here
    //setValues({ ...values, transporteur: dialogValueTP.nom });
  };

  const handleTransactionChange = (event) => {
    event.persist(event);
    setDialogValue({ ...dialogValue, [event.target.name]: event.target.value });
  };

  const addTransaction = () => {
    if (transactions.length > 0 && props.sens.toLowerCase() !== "export") {
      setDialogValue({
        ...dialogValue,
        ["transaction"]: "",
        ["contribuable"]:
          role &&
          role.user &&
          role.user.company &&
          role.user.company.account_local === "0" &&
          !role.user.company.special_authorization &&
          !role.user.company.consignataire &&
          !role.user.company.forwarding_agent &&
          ["Chargeur Principal", "Sous Compte Chargeur"].includes(
            role.user.roles[0].name,
          )
            ? role.user.company.taxpayer_id
            : transactions[0].contribuable,
      });
    }
    setOpen(true);
  };
  const removeTransaction = (_index) => {
    let _transactions = [...transactions];
    console.log("transaction at index : ", _transactions[_index]);
    if (_transactions[_index].transaction.trim().length > 13) {
      setAdded({ ...added, ["rd"]: false });
      console.log("setting rd added to false");
    } else {
      console.log("setting ep added to false");
      setAdded({ ...added, ["ep"]: false });
    }
    _transactions = _transactions.filter(
      (transaction, index) => index !== _index,
    );

    let _partnersData = [...partnersData];
    _partnersData = _partnersData.filter(
      (transaction, index) => index !== _index,
    );

    setTransactions(_transactions);
    setPartnersData(_partnersData);
  };

  useEffect(() => {
    if (props.data.length > 0) {
      console.log("TRANSACTIONS props data : ", props.data);
      setTransactions(props.data);
      const rd = props.data.filter((tx) => tx.transaction.trim().length > 13);
      const ep = props.data.filter((tx) => tx.transaction.trim().length <= 13);
      console.log("ep : ", ep, " rd : ", rd);
      if (rd.length > 0) {
        setAdded({ ...added, ["rd"]: true });
      }
      if (ep.length > 0) {
        setAdded({ ...added, ["ep"]: true });
      }
    }
  }, [props.data]);

  useEffect(() => {}, [props.chargeurs]);
  useEffect(() => {
    console.log("added changed : ", added);
  }, [added]);

  useEffect(() => {
    // console.log("partnersData changed, partnersData : ", partnersData);
    props.sendPartnersData(partnersData);
  }, [partnersData]);

  useEffect(() => {
    props.setValidity(transactions.length > 0);
    if (transactions.length > 0) {
      props.sendTransactions(transactions);
    } else {
      props.sendPartnersData(partnersData);
    }
  }, [transactions]);

  useEffect(() => {
    validateValues();
  }, [dialogValue]);

  useEffect(() => {}, [open]);

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: 300,
    },
  }));

  const classes = useStyles();
  return (
    <Card className="p-4 mb-4">
      {/* -------------------------------------- Transaction ----------------------------------- */}
      <div className="font-size-lg font-weight-bold">
        Transaction
        {(props.sens.toLowerCase() !== "export" ||
          transactions.length < 1 ||
          !added.ep ||
          !added.pr) && (
          <IconButton aria-label="delete" onClick={handleClick}>
            <AddIcon />
          </IconButton>
        )}
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          {!added.ep && (
            <MenuItem
              onClick={() => {
                handleCloseM("EP");
              }}
            >
              EP
            </MenuItem>
          )}
          {!added.rd && (
            <MenuItem
              onClick={() => {
                handleCloseM("Référence Douane");
              }}
            >
              Référence Douane
            </MenuItem>
          )}
        </Menu>
      </div>

      <form id="transaction-form">
        {transactions.map((value, index) => {
          return (
            <div>
              <Grid
                container
                direction="row"
                justifyContent="center"
                spacing={2}
                xs={12}
              >
                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_transaction_dialog_label_transaction",
                      )}
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      required
                      readOnly
                      value={value.transaction}
                      labelWidth={180}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={8} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_transaction_dialog_label_taxpayer_number",
                      )}
                    </InputLabel>
                    <OutlinedInput
                      readOnly
                      id="outlined-adornment-amount"
                      required
                      value={value.contribuable}
                      labelWidth={180}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <IconButton
                    aria-label="delete"
                    onClick={() => removeTransaction(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
          );
        })}

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <form onSubmit={handleSubmit}>
            <DialogTitle id="form-dialog-title">
              {formatMessage(
                intl,
                "create_besc_maritime_import_accordion_transaction_dialog_title",
              )}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_transaction_dialog_description",
                )}
              </DialogContentText>

              <Grid
                container
                direction="row"
                justifyContent="center"
                spacing={2}
                xs={12}
              >
                <Grid item xs={12} sm={9} md={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">
                      {type === "Référence Douane"
                        ? "Référence Douane"
                        : formatMessage(
                            intl,

                            "create_besc_maritime_import_accordion_transaction_dialog_label_transaction",
                            { type: type },
                          )}
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      required
                      value={dialogValue.transaction}
                      labelWidth={180}
                      name="transaction"
                      onChange={(event) => handleTransactionChange(event)}
                      error={errors.transaction}
                    />
                    <FormHelperText error>{helpers.transaction}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={9} md={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    className={classes.margin}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_transaction_dialog_label_taxpayer_number",
                      )}
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      required
                      value={
                        props.sens.toLowerCase() !== "export" &&
                        transactions.length > 0
                          ? transactions[0].contribuable
                          : dialogValue.contribuable
                      }
                      readOnly={
                        (props.sens.toLowerCase() !== "export" &&
                          transactions.length > 0) ||
                        (role &&
                          role.user &&
                          role.user.company &&
                          role.user.company.account_local === "0" &&
                          !role.user.company.special_authorization &&
                          !role.user.company.consignataire &&
                          !role.user.company.forwarding_agent &&
                          [
                            "Chargeur Principal",
                            "Sous Compte Chargeur",
                          ].includes(role.user.roles[0].name))
                      }
                      name="contribuable"
                      labelWidth={180}
                      onChange={(event) => handleTransactionChange(event)}
                      error={errors.contribuable}
                    />
                    <FormHelperText error>
                      {helpers.contribuable}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                {formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_transaction_dialog_btn_cancel",
                )}
              </Button>
              <Button
                type="submit"
                color="primary"
                disabled={
                  errors.transaction == true || errors.contribuable == true
                }
              >
                {formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_transaction_dialog_btn_add",
                )}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </form>
    </Card>
  );
}
